
import { defineComponent } from "@vue/runtime-core";
import ResponseData from "../../../_models/ResponseData"
import XarcadeAccountService from "../../../services/XarcadeAccountService";
import { Helper } from "@/utils/Helper";

import authFooter from "@/modules/auth/components/authFooterComponent.vue"

export default defineComponent({
  name: "viewAuthVerifySignup",
  components:{
    authFooter
  },
  data() {
    return {
      activeSection: "verifyUser",
    }
  },
  methods: {
    verifyUser() {
      this.activeSection = 'loadingVerifyUser';
      let verifyToken = this.$route.query.token!.toString();

      XarcadeAccountService.verifyRegistration(verifyToken)
        .then((response: ResponseData) => {
          if (response.status === 200) {
            this.activeSection = 'verifyUserSuccess';
            localStorage.setItem("tooltip", "show"); 
            Helper.toastSuccessHandling(response.data['message']);
          } else {
            this.activeSection = 'verifyUser';
            Helper.endpointErrorHandling(response);
          }
        }).catch((error) => {
          this.activeSection = 'verifyUser'
          Helper.endpointErrorHandling(error);
        });
    }
  }
});
